import {useQuery} from '@tanstack/react-query';
import {useSelector} from 'react-redux';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';
import {logWithSentry} from 'libs/sentry/sentry';

import {getTotalsLoadedWithTax} from '../../store/selectors/orderReviewTotals/orderReviewTotals';

const PRIMER_TOKEN_QUERY_KEY = 'PRIMER_TOKEN_QUERY_KEY';
/**
 * gets primer token
 * */
export function useGetPrimerToken() {
    const isTotalsWithTaxLoaded = useSelector(getTotalsLoadedWithTax);
    const {data, isFetching} = useQuery<{clientToken: string} | null>({
        enabled: isTotalsWithTaxLoaded,
        queryFn: async () => {
            try {
                const response = await apiConfig.instanceGusaBackend<{clientToken: string}>({
                    method: 'POST',
                    url: ENDPOINTS.PRIMER_CREATE_TOKEN,
                });
                return response.data;
            } catch (e) {
                logWithSentry(e, 'Cannot get Primer token');
                return null;
            }
        },
        queryKey: [PRIMER_TOKEN_QUERY_KEY],
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    });

    // to not return previous token when a new one is fetching
    return {token: isFetching ? '' : data?.clientToken};
}
